var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"collegeStatistics",staticClass:"hcsjn",staticStyle:{"width":"100%","height":"400px","background-color":"aqua"}})
}
var staticRenderFns = []

export { render, staticRenderFns }